
import { CompanyBuildingIcon } from '@/asset/icons'
import React from 'react'

const IconBadge = ({ icon, style }) => {
    return (
        <div className='w-14 h-14 rounded-full bg-[#FFECE5] flex items-center justify-center box-border p-2' style={style ?? {}}>
            {icon ?? <CompanyBuildingIcon />}
        </div>
    )
}

export default IconBadge